<template>
  <section>
    <div class="card-body">
      <h6 class="text-center">({{ index }}/10)</h6>
      <div class="row bg-light mx-2 py-2 mb-4" v-if="tip">
        <div class="col-1">
          <img id="f1" src="@/assets/images/oliver.png" />
        </div>
        <div class="col-11">
          <b class="font-weight-bold">
            {{ $t("lang.onBoarding.tip") }}
          </b>
          {{ $t("lang.onBoarding." + value + "_tip",this.$store.state.onboarding.lang) }}
        </div>
      </div>
      <span class="img-btn pl-1 mt-2">
           <img src="@/assets/images/arrow-down.png" alt />
      </span>
      <span class="lead d-inline"> 
        {{ $t("lang.onBoarding.example",this.$store.state.onboarding.lang) }} 
      </span>
      <h5 class="pt-2 pb-2" v-if="type == 1">
        <b class="text-primary">{{ $t("lang.onBoarding." + value + "_prepend",this.$store.state.onboarding.lang) }} {{ $t("lang.onBoarding.oliverlist",this.$store.state.onboarding.lang) }}</b>
        {{ $t("lang.onBoarding." + value + "_example",this.$store.state.onboarding.lang) }}
      </h5>
      <h5 class="pt-2 pb-2" v-if="type == 2">
        <b class="text-primary">{{ $t("lang.onBoarding." + value + "_prepend",this.$store.state.onboarding.lang) }}</b>
        {{ $t("lang.onBoarding." + value + "_example",this.$store.state.onboarding.lang) }}
      </h5>
      <h5 class="pt-2 pb-2" v-if="type == 3">
        {{ $t("lang.onBoarding." + value + "_prepend",this.$store.state.onboarding.lang) }}
        <b class="text-primary" v-if="subStep != 13">{{ $t("lang.onBoarding.business",this.$store.state.onboarding.lang) }}</b>
        {{ $t("lang.onBoarding." + value + "_apend",this.$store.state.onboarding.lang) }}
      </h5>

      <h5 class="pt-2 pb-2" v-if="subStep == 12">
        {{ $t("lang.onBoarding." + value + "_prepend",this.$store.state.onboarding.lang) }}
        <b class="text-primary">{{ $t("lang.onBoarding."+value+"_example",this.$store.state.onboarding.lang) }} </b>,
        <b class="text-primary">{{ $t("lang.onBoarding."+value2+"_example",this.$store.state.onboarding.lang) }} </b> or
        <b class="text-primary">{{ $t("lang.onBoarding."+value3+"_example",this.$store.state.onboarding.lang) }}</b>
        {{ $t("lang.onBoarding." + value + "_apend",this.$store.state.onboarding.lang) }}
      </h5>
      
      <div v-if="subStep == 11">
        <h5 class="pt-2">
          <b class="text-primary">{{ $t("lang.onBoarding." + value + "_prepend",this.$store.state.onboarding.lang) }}</b>
        </h5>
        <ul class="list-group lead">
          
          <li class="list-group-item border-0 pl-1 py-1 h5">- {{ $t("lang.onBoarding."+value+"_example",this.$store.state.onboarding.lang) }}</li>
          <li class="list-group-item border-0 pl-1 py-1 h5">- {{ $t("lang.onBoarding."+value2+"_example",this.$store.state.onboarding.lang) }}</li>
          <li class="list-group-item border-0 pl-1 py-1 h5">- {{ $t("lang.onBoarding."+value3+"_example",this.$store.state.onboarding.lang) }}</li>
        </ul>
      </div>


      <p class="mt-4"> {{ $t("lang.onBoarding.and_you",this.$store.state.onboarding.lang) }} </p>

      <div class="input-group  input-group-lg " v-if="type < 3">
        <div class="input-group-prepend w-100">
          <span class="d-flex align-items-start input-group-text font-weight-bold bg-white px-0 border-0"
            v-if="type == 1">
            {{ $t("lang.onBoarding." + value + "_prepend",this.$store.state.onboarding.lang) }}  {{ productName }}
            </span>
          <span v-if="(subStep == 3 || subStep == 10)" class="d-flex align-items-start input-group-text font-weight-bold bg-white px-0 border-0">,</span>
          <span class="d-flex align-items-start input-group-text font-weight-bold bg-white px-0 border-0"
            v-if="type == 2">{{ $t("lang.onBoarding." + value + "_prepend",this.$store.state.onboarding.lang) }} </span>
        <input class="d-inline text-primary mb-1 lead pl-2 w-100 border-style-dashed"  ref="inputOne"
          :placeholder='$t("lang.onBoarding." + value + "_example",this.$store.state.onboarding.lang)' type="text" :value="step1[value]" @input="updateText" />
        </div>
        <span v-if="showAvailableCharacters" 
        class="col-12 text-center" :class="charactersClass">{{ $t('lang.label.charactersavailable', this.$store.state.onboarding.lang,{actual: step1[value].length, total: valueMaxLength})}}</span>
      </div>

      
      <div class="input-group input-group-lg  bg-white" v-if="type == 3">
        <span class="lead text-dark pt-2 pl-3 font-weight-bold  pl-0 bg-white">{{ $t("lang.onBoarding." + value + "_prepend",this.$store.state.onboarding.lang) }}</span>
        <input class="d-inline text-primary mx-2 mb-1 lead pl-2 border-style-dashed" maxlength="30"  ref="inputOne"
          :placeholder='$t("lang.onBoarding." + value + "_example",this.$store.state.onboarding.lang)' type="text" :value="step1[value]" @input="updateText">

        <span class="lead text-dark pt-2 font-weight-bold bg-white">
          {{ $t("lang.onBoarding." + value + "_apend",this.$store.state.onboarding.lang) }}
        </span>
        <span v-if="showAvailableCharacters"  class="col-12 text-center" :class="charactersClass">{{ $t('lang.label.charactersavailable', this.$store.state.onboarding.lang,{actual: step1[value].length, total: valueMaxLength})}}</span>

      </div>
  
      <div class="input-group input-group-lg font-weight-bold bg-white" v-if="type == 4">
        <span class="lead text-dark pt-2 pl-3 font-weight-bold  pl-0 bg-white">{{ $t("lang.onBoarding." + value + "_prepend",this.$store.state.onboarding.lang) }}</span>
        <input class="d-inline text-primary mx-2 mb-1 lead pl-2 border-style-dashed"  maxlength="30"  ref="inputOne"
               :placeholder='$t("lang.onBoarding." + value + "_example",this.$store.state.onboarding.lang)' type="text"  :value="step1[value]" 
          @input="updateText">
        <span class="lead text-dark pt-2 font-weight-bold bg-white"> , </span>
        <input class="d-inline text-primary mx-2 mb-1 lead pl-2 border-style-dashed"  maxlength="30"  ref="inputTwo"
               :placeholder='$t("lang.onBoarding." + value2 + "_example",this.$store.state.onboarding.lang)' type="text" :value="step1[value2]"
          @input="updateText2"> 
        <span class="lead text-dark pt-2 font-weight-bold bg-white">
          {{ $t("lang.filters.or",this.$store.state.onboarding.lang) }} </span>
        <input class="d-inline text-primary mx-2 mb-1 lead pl-2 border-style-dashed"   maxlength="30"  ref="inputThree"
              :placeholder='$t("lang.onBoarding." + value3 + "_example",this.$store.state.onboarding.lang)'type="text" :value="step1[value3]"
          @input="updateText3">
        <span class="lead text-dark pt-2 font-weight-bold bg-white">
          {{ $t("lang.onBoarding." + value + "_apend",this.$store.state.onboarding.lang) }}
        </span>
      </div>


      

      <div v-if="type == 5">

        <span class="lead text-dark pt-2 pl-3 font-weight-bold  pl-0 bg-white">{{ $t("lang.onBoarding." + value + "_prepend",this.$store.state.onboarding.lang) }}</span>
        <div class="input-group input-group-lg bg-white">
          <span class="d-flex input-group-text font-weight-bold bg-white border-0 pr-0">-</span>
          <input class="w-50 d-inline text-primary mx-2 mb-1 lead pl-2 border-style-dashed" maxlength="100"  ref="inputOne"
              :placeholder='$t("lang.onBoarding." + value + "_example",this.$store.state.onboarding.lang)'
            type="text" :value="step1[value]" @input="updateText">
           
          <span v-if="showAvailableCharacters" class="col-12 text-center" :class="charactersClass">{{ $t('lang.label.charactersavailable', this.$store.state.onboarding.lang,{actual: step1[value].length, total: valueMaxLength})}}</span>
        </div>
        <div class="input-group input-group-lg bg-white">
          <span class="d-flex input-group-text font-weight-bold bg-white border-0 pr-0">-</span>
          <input class="w-50 d-inline text-primary mx-2 mb-1 lead pl-2 border-style-dashed" maxlength="100"  ref="inputTwo"
              :placeholder='$t("lang.onBoarding." + value2 + "_example",this.$store.state.onboarding.lang)'
            type="text" :value="step1[value2]" @input="updateText2">
         
          <span v-if="showAvailableCharacters2" class="col-12 text-center" :class="charactersClass2">{{ $t('lang.label.charactersavailable', this.$store.state.onboarding.lang,{actual: step1[value2].length, total: valueMaxLength})}}</span>
        
        </div>
        <div class="input-group input-group-lg bg-white">
          <span class="d-flex input-group-text font-weight-bold bg-white border-0 pr-0">-
          </span>  
          <input class="w-50 d-inline text-primary mx-2 mb-1 lead pl-2 border-style-dashed" maxlength="100"  ref="inputThree"
              :placeholder='$t("lang.onBoarding." + value3 + "_example",this.$store.state.onboarding.lang)'
            type="text" :value="step1[value3]" @input="updateText3">
        
          <span v-if="showAvailableCharacters3"  class="col-12 text-center" :class="charactersClass3">{{ $t('lang.label.charactersavailable', this.$store.state.onboarding.lang,{actual:step1[value3].length, total: valueMaxLength})}}</span>

        </div>
      </div>
    </div>

  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data () {
        return { 
            valueMaxLength: 0,
            showAvailableCharacters: false,
            showAvailableCharacters2: false,
            showAvailableCharacters3: false,
            charactersClass: "text-secondary",
            charactersClass2: "text-secondary",
            charactersClass3: "text-secondary"
        }
    },
   computed: {
    ...mapState({
      productName: state => state.onboarding.productName,
      step1: state => state.onboarding.step1
    })
  },


  props: {
    subStep: Number,
    orderName: String,
    tip: Boolean,
    type: Number,
    index: Number,
    value: String,
    value2: String,
    value3: String,
  },

  mounted(){
    if(this.$refs.inputOne)
      this.changewidthOnLoad(this.$refs.inputOne)
    
    if(this.$refs.inputTwo)
      this.changewidthOnLoad(this.$refs.inputTwo)
    
    if(this.$refs.inputThree)
      this.changewidthOnLoad(this.$refs.inputThree)

    
    if (this.type == 3)
      this.valueMaxLength = 50
    else if(this.type == 4)
      this.valueMaxLength = 30
    else if(this.type == 5)
      this.valueMaxLength = 100
    else
      this.valueMaxLength = 150
  },

  methods: {
    ...mapActions("onboarding", {
      updateServiceDescription: "updateServiceDescription"
    }),

    updateText(e) {
      this.changewidth(e)
      this.updateServiceDescription({ substep: this.subStep, text: e.target.value , order: 1 })
      if (e.target.value.length == this.valueMaxLength)
        this.charactersClass = "text-danger"
      else
        this.charactersClass = "text-secondary"
      this.showAvailableCharacters = true


    },
    updateText2(e) {
      this.changewidth(e)
      this.updateServiceDescription({ substep: this.subStep, text: e.target.value, order: 2 })
      if (e.target.value.length == this.valueMaxLength)
        this.charactersClass2 = "text-danger"
      else
        this.charactersClass2 = "text-secondary"
      this.showAvailableCharacters2 = true
    },
    updateText3(e) {
      this.changewidth(e)
      this.updateServiceDescription({ substep: this.subStep, text: e.target.value, order: 3 })
      if (e.target.value.length == this.valueMaxLength)
        this.charactersClass3 = "text-danger"
      else
        this.charactersClass3 = "text-secondary"
      this.showAvailableCharacters3 = true
    },
    changewidth(e){
      let result;
      result = this.measureText(e.target.value, 20, e.target.style)
      if(result.width<(screen.width*0.5)){
        e.target.style.width = result.width+11 + "px";
      }
    },
    changewidthOnLoad(input){
      let result;
      result = this.measureText(input.value, 20, input.style)
      //console.log(result.width, screen.width)
      if(result.width>8){
        if(result.width<(screen.width*0.5)){
        //  console.log(result.width, screen.width)
          input.style.width = result.width+11 + "px";
        } else {
          input.style.width = screen.width*0.5 + "px";
        }

      } else {
        input.style.width = "15em";
      }
    },

    measureText(pText, pFontSize, pStyle) {
      var lDiv = document.createElement('div');

      document.body.appendChild(lDiv);

      if (pStyle != null) {
          lDiv.style = pStyle;
      }
      lDiv.style.fontSize = "" + pFontSize + "px";
      lDiv.style.position = "absolute";
      lDiv.style.left = -1000;
      lDiv.style.top = -1000;

      lDiv.textContent = pText;

      var lResult = {
          width: lDiv.clientWidth,
          height: lDiv.clientHeight
      };

      document.body.removeChild(lDiv);
      lDiv = null;

      return lResult;
    }

  }
}
</script>

<style>
input:focus{
    outline: none;
}
.border-style-dashed{
  border-style: dashed;
  border-bottom:1px dashed;
  border-top: 0px;
  border-left: 0px;
  border-right: 0px;
}
</style>